import { goRequest } from '../utils/httpClientTs';
import {
  ContactUsCategory,
  ContactUsRequest,
  ContactUsResponse,
} from '../types/feedback';

export const getContactUsCategories = async (): Promise<
  ContactUsCategory[]
> => {
  return goRequest<ContactUsCategory[]>({
    url: '/feedback/contact_us_categories',
    method: 'GET',
  });
};

export const createContactUs = async (
  data: ContactUsRequest
): Promise<ContactUsResponse> => {
  return goRequest<ContactUsResponse>({
    url: '/feedback/contact_us',
    method: 'POST',
    data: data,
  });
};
